export default "__VITE_ASSET__BZ$mrccm__"